<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-03-06 17:06:20
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-12 17:58:24
 * @FilePath: /chaoyongtuan/src/views/shopManage/shopLibrary/addMaterial/components/good/components/moreList.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="list-content">
		<div class="list-all" v-for="(item, index) in list" :key="index" @click="onChangStatus(item)">
			<div class="list-li">
				<div class="list-li-content flex flex-align-center">
					<div class="flex flex-align-center list-one fz-12">
						<div>{{ item.commissionRate }} %</div>
						<div v-if="show" class="ml-10 cursor-pointer" :class="[!+item.hasOpenCommissionRate ? 'rate-color-b4' : 'rate-color-g5']" @click="onChangStatus(item)">{{
							!+item.hasOpenCommissionRate ? '设为公开佣金' : '已设为公开佣金'
						}}</div>
					</div>
					<div class="ml-20 list-two fz-12">
						<div>{{ item.serviceRate }} %</div>
					</div>
					<div class="ml-20 fz-12">
						<el-tag :useByTable="false">{{ item.productTypeName }}</el-tag>
					</div>
					<div class="ml-20 mr-10 fz-12">
						<div class="flex flex-align-center">
							<div :class="['state_icon', +item.otherStatus == 1 ? 'success' : 'danger']"></div>
							<div class="ml-10">{{ item.otherStatusDesc }}</div>
						</div>
					</div>
					<div class="time-content ml-20 fz-12">
						<img class="time-icon" src="@/assets/public/time-icon.png" alt="" />
						<div>{{ item.promotionStartTime }}</div>
						<div>{{ item.promotionEndTime }}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		list: {
			type: Array,
			default: () => [],
		},
		updateStatus: {
			type: Boolean,
			default: false,
		},
		show:{
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
		};
	},
	methods: {
		onChangStatus(item) {
			this.$emit('settingCallback', item);
		},
	},
};
</script>
<style lang="less" scoped>
.list-content {
	max-height: 406px;
	overflow: auto;
	.list-all {
		border-bottom: 1px solid #f0f1f5;
	}
	.list-li {
		padding: 20px 10px 20px 24px;
	}
}
.list-one {
	width: 160px;
}
.list-two {
	text-align: left;
	width: 60px;
}
.state_icon {
	width: 8px;
	height: 8px;
	border-radius: 50%;
}
.time-content{
    position: relative;
    .time-icon{
        position: absolute;
        left: -12px;
        top: 5px;
        width: 10px;
        height: 34px;
    }
}
.success {
	background-color: @color-success;
}
.danger {
	background-color: @color-danger;
}
.rate-color-b4 {
	color: @color-b4;
}
.rate-color-g5{
	color: #0C9F1B;
}
</style>
